<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  components: {},
  computed: {}
}
</script>

<style lang="sass">

    @import url('https://fonts.googleapis.com/css?family=Roboto')

    html, body
        height: 100%
        font-size: 14px

    main
        min-height: 100%
        background-color: #ededed
        font-family: 'Roboto', sans-serif
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale
        color: #2c3e50
        &.dark
            background-color: #efefef

    .container
        @media (min-width: 768px) and (max-width: 1087px)
            max-width: 740px
            width: 740px

    form
        background-color: #efefef
        height: 100%

    a
        color: #e48d08
    /*font-weight: 700*/

    .button
        border-radius: 0
        font-weight: 700

    header
        position: fixed
        z-index: 5
        width: 100%
        background-color: white
        &:after
            content: ""
            background-color: white
            opacity: 0.9
            top: 0
            left: 0
            bottom: 0
            right: 0
            position: absolute
            z-index: -1
        &.bx-header
            padding: 0.5rem 2rem
            @media (max-width: 768px)
                padding: 0.5rem
            height: 100px
            display: flex
            align-items: center
            justify-content: space-between
            img
                /*width: 20%*/
                /*margin-top: 20px*/
                /*min-width: 150px*/
                /*height: auto*/
                width: auto
                max-height: 50px
                @media (max-width: 768px)
                    margin-top: 10px
                    max-height: 40px
                    max-width: 85px
        /*min-width: 75px*/
        // Request for Quote
        span
        /*display: block*/
        /*margin: 0 0 5px 0*/
        /*font-size: 1.5rem*/
        /*@media (max-width: 768px)*/
          /*font-size: 1rem*/
        @media (max-width: 768px)
            &.bx-header
                height: 76px

    // Transitions (may not be being used but here for good measure)
    .fade-enter-active, .fade-leave-active
        transition: opacity .3s

    .fade-enter, .fade-leave-to
        opacity: 0

    //
    .is-inline-flex
        align-items: center

    .total-items-wrapper
        @media (min-width: 768px)
            margin: 0 0 5px 0
        @media (max-width: 768px)
            line-height: 1.2
            padding: 0.4rem 0

    span.date-larger
        font-size: 1rem
        @media (max-width: 768px)
            font-size: 1rem

    p.scope-question
        font-size: 0.8rem

    .total-items
        font-size: 1.1rem
        text-align: right
        &--top-border
            margin-top: 5px
            padding-top: 5px
            border-top: 2px solid #999
        // Currency spans
        span
            display: inline-block
            width: 160px
            @media (max-width: 768px)
                width: 80px
        &:last-of-type
            font-weight: bold

    .flex-center
        justify-content: center

    .section
        padding-top: 120px
        padding-bottom: 350px
        @media (max-width: 768px)
            padding-top: 100px
            padding-bottom: 175px

    .content
        max-width: 900px
        margin: 0 auto

    section#please-add
        width: 100%
        section
            padding: 1.25rem 0
            @media (max-width: 600px)
                padding: 1rem 0
            .title
                @media (max-width: 600px)
                    font-size: 1rem
        background: rgba(#ffca0a, 0.9)

    .scope-panel
        border-radius: 3px
        padding: 10px
        background: #fefefe
        width: 100%

    .scope-description-wrapper
        min-height: 228px
        display: flex
        flex-direction: column
        justify-content: space-between
    //
    .info-panel
        padding: 10px 16px
        width: 100%
        line-height: 1.25
        background-color: #e9e9e9
        border: 1px solid #ddd
        min-height: 120px
        border-radius: 3px

    .title-info-panel
        margin: 0.25rem 0 0.5rem 0 !important
        font-size: 1.2rem !important
        font-weight: 400
        @media (max-width: 768px)
            margin: 0 !important
            font-weight: 500
            text-decoration: underline

    .scope-attachments
        min-height: 200px
        margin-top: 10px
        a
            color: #111
        .tab-panel-listing
            margin-top: 10px
            .column
                i
                    font-size: 1rem
                a
                    display: inline-block
                    background: #ddd
                    text-align: center
                    padding: 15px
                    border-radius: 2px
                    width: 100%
                    font-size: 0.8rem
                    -webkit-transition: all 0.3s ease
                    -moz-transition: all 0.3s ease
                    -ms-transition: all 0.3s ease
                    -o-transition: all 0.3s ease
                    transition: all 0.3s ease
                    &:hover
                        background: #606060
                        color: #fefefe
                    //
                    &.btn-attachment-download
                        border-top: 1px solid #aaa
                        padding: 5px 0

    .level--attachment-item-row
        border-bottom: 1px dashed #efefef !important
        font-size: 1rem

    .title
        @media (max-width: 768px)
            line-height: 1.5

    #discussion
        background: #d4d4d4
        position: relative
        padding-bottom: 200px !important
        @media (max-width: 768px)
            margin-top: auto
        -webkit-box-shadow: inset 2px 0 0 0 rgba(0, 0, 0, 0.1)
        -moz-box-shadow: inset 2px 0 0 0 rgba(0, 0, 0, 0.1)
        box-shadow: inset 2px 0 0 0 rgba(0, 0, 0, 0.1)
        #toggle_messages
            padding: 60px 20px 170px
            .column
                padding-left: 0 !important
                padding-right: 0 !important
            @media (min-width: 768px) and (max-width: 1087px)
                padding: 60px 30px 170px
            @media (min-width: 1008px)
                padding: 60px 10px 170px
        article
            margin: 0
            *
                padding: 10px

    .message
        margin: 0 10px
        @media (max-width: 768px)
            margin: 0

    .message-box
        position: relative
        padding: 20px 10px 10px !important
        line-height: 1.25
        font-size: 0.9rem

    .message-time
        position: absolute
        right: -4px
        top: -4px
        font-size: 0.7rem
        color: #ccc

    // This is effectively a mix in
    .btn-fixed
        position: fixed
        width: auto
        padding: 10px
        background: none
        border: none
        -webkit-transform: scale(1, 1)
        -moz-transform: scale(1, 1)
        -ms-transform: scale(1, 1)
        -o-transform: scale(1, 1)
        transform: scale(1, 1)
        cursor: pointer
        font-size: 1.2rem
        color: #000
        @media(max-width: 768px)
            font-size: 1.5rem
            background: none
            border: none
            right: -6px
            span
                font-size: 0.8rem
        &:focus
            outline: none
        -webkit-transition: all 0.3s ease
        -moz-transition: all 0.3s ease
        -ms-transition: all 0.3s ease
        -o-transition: all 0.3s ease
        transition: all 0.3s ease
        button
            color: #fff
            background: none
            border: none
            font-size: 1.25rem
            cursor: pointer
            text-align: center
            &:focus
                outline: none
        i
            font-size: 1.75rem
            display: block
            height: 22px
            @media (max-width: 768px)
                font-size: 1.25rem
                height: 10px

    .btn-fixed--active
        span
            text-decoration: underline

    .btn-toggle-messages
        top: 20px
        right: 120px
        z-index: 10
        @media (max-width: 768px)
            top: 16px
            right: 60px

    .btn-toggle-status
        top: 20px
        right: 20px
        z-index: 11
        @media (max-width: 768px)
            top: 16px
            right: 0

    .btn-close-messages
        position: absolute
        top: 10px
        right: 10px
        color: #111
        z-index: 1000

    .btn-save
        top: 150px
        z-index: 1

    .message-field
        margin: 5px 0
        font-size: 0.9rem
        line-height: 1.25

    .textarea
        height: 168px

    input[type="button"], button[type="button"], button
        border-radius: 3px

    .btn-primary
        color: white
        background: orange
        padding: 10px 20px
        margin: 10px 0
        font-weight: 700
        font-size: 1.2rem
        cursor: pointer
        border: none
        width: 100%
        &:focus
            outline: none
        /*&:hover*/
          /*color: orange*/
          /*background: white*/
        @media (max-width: 768px)
            padding: 5px 20px

    .level-item .btn-primary
        height: 40px

    .btn-secondary
        color: white
        background: #aaa
        padding: 10px 20px
        margin: 10px 0
        font-weight: 700
        font-size: 1.2rem
        cursor: pointer
        border: none
        width: 100%
        &:focus
            outline: none

    .btn-tertiary
        color: white
        background: #bcbcbc
        padding: 10px 20px
        font-weight: 700
        margin: 10px 0
        font-size: 1.2rem
        cursor: pointer
        border: none
        width: 100%
        &:focus
            outline: none

    .btn-invite
        color: #fff
        background: orange
        border: none
        font-weight: 700
        padding: 10px 20px
        margin: 10px 0
        font-size: 1.2rem
        min-width: 200px
        width: 100%
        cursor: pointer
        &:focus
            outline: none
        &[disabled=disabled]
            opacity: 0.5
            cursor: not-allowed

    .footer-logo
        width: 100px
        @media (max-width: 768px)
            width: 88px

    .footer
        position: fixed
        bottom: 0
        width: 100%
        z-index: 2000
        padding: 0
        background: rgba(255, 255, 255, 0.8)
        .level
            border-top: 1px solid #999
            color: #454545
            font-size: 0.75rem
            padding: 1rem
            background: #dedede
            strong
                color: #454545
            @media (max-width: 768px)
                font-size: 0.7rem
                padding: 0.4rem 1rem
        .level-footer-buttons
            margin: 0
            /*background: rgba(#aaa, 0.7)*/
            /*background: rgba(255,255,255, 0.9)*/
            @media (max-width: 1088px)
                padding: 0 20px
            display: flex
            .column
                display: flex
                justify-content: center
                align-items: center
                flex: 1 0 0
                font-size: 1.25rem
                &.column--left
                    padding-left: 0
                /*@media (min-width: 769px)*/
                &.column--right
                    padding-right: 0
                /*@media (min-width: 769px)*/
                @media (max-width: 768px)
                    padding: 5px
        //
        .button
            font-size: 1.2rem
            height: 22px
            background: none
            padding: 0
            border: none
            color: orange
            /*font-weight: 700*/
            &:hover
                background: none

    .footer--accept
        left: 0
        bottom: 55px
        @media (max-width: 768px)
            bottom: 32px

    .footer--reopen
        left: 0
        bottom: 220px
        z-index: 5000
        padding: 10px 0
        @media (max-width: 768px)
            bottom: 175px
            padding: 0 20px
        span
            font-size: 1.2rem
            padding-top: 20px

    .footer-hover
        text-align: center !important
        -webkit-transition: all 0.3s ease
        -moz-transition: all 0.3s ease
        -ms-transition: all 0.3s ease
        -o-transition: all 0.3s ease
        transition: all 0.3s ease
        cursor: pointer
        @media (max-width: 768px)
            padding: 0.3rem 1rem
        &:hover
            background-color: rgba(255, 255, 255, 0.2)

    .level-right--short-mbl
        /*margin-top: 0.5rem !important*/
        @media(max-width: 768px)
            position: relative
            top: 8px
            right: -12px

    // Can apply to both table or ul modes
    .items-list-box
        padding: 5px
        background-color: #e0e0e0
        margin-bottom: 10px

    .items-list
        width: 100%
        th
            background-color: #999 !important
            color: #fafafa
            padding: 2px
        li, tr
            /*border-bottom: 1px dotted #ccc*/
            td
                padding-bottom: 10px
                padding-top: 10px
                &:first-child
                    @media (min-width: 768px)
                        padding-left: 5px
                &:last-child
                    padding-right: 5px
        tr
            &:nth-child(odd)
                background: #fafafa
            @media (max-width: 1024px)
                border-bottom: 2px solid #ccc
                background: #dedede
                margin-bottom: 10px
                padding: 0 5px
                border-radius: 2px
                &:last-child
                    margin-bottom: 0

    table > td
        padding: 10px 0

    td.td-centered, th.th-centered
        text-align: center

    /*
     *https://css-tricks.com/responsive-data-tables/
     *Max width before this PARTICULAR table gets nasty
     *This query will take effect for any screen smaller than 760px
     *and also iPads specifically.
    @media (max-width: 760px)
        /* Force table to not be like tables anymore
        table, thead, tbody, th, td, tr
            display: block
        th
            display: none
        /* Hide table headers (but not display: none;, for accessibility)
        thead tr
            position: absolute
            top: -9999px
            left: -9999px
        tr
            border-bottom: 1px dotted #ccc
        td
            /* Behave  like a "row"
            border: none
            /*border-bottom: 1px solid #eee;
            position: relative
            padding-left: 75px
        td.td-centered, th.th-centered
            text-align: left
        td:before
            /* Now like a table header
            position: absolute
            /* Top/left values mimic padding
            top: 11px
            left: 4px
            width: 25%
            padding-right: 25px
            white-space: nowrap
            font-weight: bold
            font-size: 80%
        /*
         *Label the data
        td:nth-of-type(1):before
            content: "Description"
        td:nth-of-type(2):before
            content: "Qty"
        td:nth-of-type(3):before
            content: "UOM"
        td:nth-of-type(4):before
            content: "Amount"
        td:nth-of-type(5):before
            content: "Tax"

    .currencyPrefix, .td__top-adjust
        position: relative
        top: 4px
        left: -5px
        font-size: 0.8rem

    .td__item-details
        background-color: #dedede
        padding-left: 5px
        border-radius: 4px

    .instruction-label__unit-price
        position: absolute
        display: block
        right: 3em
        top: 5em
        text-align: center
        line-height: 1.5
        font-size: 0.8em
    // Aside notification
    //
    #notificationContainer
        position: fixed
        top: 200px
        right: 5px
        z-index: 100
        @media (max-width: 768px)
            top: 60px
            right: 0

    aside.notification
        width: 300px
        margin: 5px 5px 0 0 !important
        padding: 10px
        background-color: #f6fbfe
        position: relative
        -webkit-transition: all 0.5s ease
        -moz-transition: all 0.5s ease
        -ms-transition: all 0.5s ease
        -o-transition: all 0.5s ease
        transition: all 0.5s ease
        &.inactive
            opacity: 0
            right: -150px

    a.notification__icon
        position: absolute
        top: 10px
        right: 10px

    .badge
        border-radius: 50% !important
        padding: 0
        position: absolute
        right: 10px
        top: -5px

    sup
        font-size: 1.5rem

    span.form-step
        color: #219cef
        font-size: 1.2rem
        display: inline-block
        margin-bottom: 10px

    // Not found
    h1.not-found
        font-size: 2rem

    .header-top
        height: 60px
        padding: 10px

    // Animation keyframes for button
    .button
        -webkit-transition: all 0.5s ease-in-out
        -moz-transition: all 0.5s ease-in-out
        -ms-transition: all 0.5s ease-in-out
        -o-transition: all 0.5s ease-in-out
        transition: all 0.5s ease-in-out

    .btn-transparent
        background: none
        border: none
        opacity: 1

    .file-upload-label
        background: #202020
        color: white
        border-radius: 0
        display: inline-block
        margin: 0.1rem 0 0.2rem 0
        position: relative
        padding: 0.5rem 4rem
        cursor: pointer
        font-size: 1.1rem
        text-transform: uppercase
        font-weight: 700
        border-radius: 3px

    .file-upload-spinner
        position: absolute
        left: 30px
        top: 2px

    .button.is-loading::after, .control.is-loading::after, .loader, .select.is-loading::after
        border: 2px solid #8a8a8a
        border-top-color: transparent
        border-right-color: transparent

    .button.white-loader::after
        border: 2px solid #ffffff !important
        border-top-color: transparent !important
        border-right-color: transparent !important

    article.message
        margin: 0

    .totals
        /*position: fixed*/
        /*bottom: 125px*/
        /*width: 100%*/
        /*left: 0*/
        .container
        /*background: rgba(255,255,255,0.9)*/
        .column
        /*padding-bottom: 0*/
        /*z-index: 1000*/
        /*border-top: 2px solid #bbb*/
        padding: 0 5px
        ///1.5rem
        @media (max-width: 1088px)
            padding: 0 20px
    /*bottom: 122px*/
    section.panel
        padding: 5px 16px
        border: 1px solid #dbdbdb
        border-top: none

    .section-above-footer-fixed
        position: fixed
        bottom: 200px
        width: 100%
        margin: 0
        left: 0
        @media (max-width: 768px)
            bottom: 148px

    input[type=checkbox]
        position: absolute
        top: -9999px
        left: -9999px

    input[type=checkbox]:checked + label
        &:before
            font-family: 'Font Awesome 5 Free'
            content: '\f058'
    // Circle-Checked
    input[type=checkbox] + label
        &:before
            font-family: 'Font Awesome 5 Free'
            content: '\f111'
    // Circle
    label[for=cb_tax]
        position: absolute
        bottom: 38px
        left: 10px
        @media (max-width: 768px)
            font-size: 0.75rem

    .text-autosave
        position: absolute
        bottom: 16px
        font-size: 0.75rem
        left: 10px

    .uploads-list
        margin-bottom: 1rem
        @media(min-width: 769px)
            padding: 5px 0 0 20px
        li
            font-size: 0.75rem
    //
    .progress-bar
        position: fixed
        z-index: 1000
        left: 50%
        margin-left: -60px
        top: 20px
        display: flex
        height: 50px
        align-items: center
        justify-content: center
        @media (max-width: 768px)
            height: 40px
            top: 0
        .progress-track
            background: #ccc
            margin-top: -10px
            height: 3px
            border-radius: 2px
            padding: 0
            display: flex
            justify-content: space-around
            overflow: visible
            .progress-item
                -webkit-transition: all 0.3s ease
                -moz-transition: all 0.3s ease
                -ms-transition: all 0.3s ease
                -o-transition: all 0.3s ease
                transition: all 0.3s ease
                display: flex
                align-items: center
                flex-direction: column
                overflow: visible
                height: 40px
                margin-top: -8px
                margin-left: 0.25rem
                margin-right: 0.25rem
                &--first
                    margin-left: 0
                &--last
                    margin-right: 0
                font-size: 0.7rem
                color: #ccc
                cursor: default
                pointer-events: none
                span
                    display: block
                    width: 18px
                    height: 18px
                    border-radius: 50%
                    background: #fff
                    font-size: 1.3rem
                    &:before
                        font-family: 'Font Awesome 5 Free'
                        content: '\f111'
                        // Circle
                        position: relative
                        top: -4px
                        left: 0
            .progress-current
                color: orange
                span
                    background: white
                    &:before
                        color: orange
            .progress-reached
                cursor: pointer
                pointer-events: all
                span
                    &:before
                        content: '\f058'
                &:hover
                    color: orange
                    span
                        background: white
                        &:before
                            color: orange

    .tabs.is-boxed
        margin-bottom: 0
        li.is-active a
            background-color: #e9e9e9
            color: #363636

    .owl-stage-outer
    /*overflow: visible !important*/
    .section-items-carousel-item
        padding: 1rem
        background: linear-gradient(#dfdfdf, #efefef)
        width: 100%
        height: calc(100vh - 400px)
        overflow: scroll
        ul
            li
                font-size: 0.9rem
                padding: 0 0 1rem 0
                line-height: 1.4
                display: flex
                align-items: center
                label.left
                    color: #888
                    width: 90px
                    display: inline-block
                div.item-value-touch
                    display: inline-block

    .dropdown-menu
        min-width: 7.1rem
    // owl stuff
    figure
        color: green
        font-size: 1.2rem
        font-weight: 700

    .owl-arrows
        width: 100%
        display: flex
        justify-content: space-between
        position: absolute
        top: 322px
        button
            &.disabled
                opacity: 0.1
            &.owl-prev
                padding-left: 3px
                background: none
                -webkit-appearance: none
                border: none
                span
                    padding: 0 1rem 0 0
            &.owl-next
                padding-right: 3px
                background: none
                -webkit-appearance: none
                border: none
                span
                    padding: 0 0 0 1rem
            span
                font-size: 2.5rem

    .message-error
        position: fixed
        top: 10px
        width: 100%
        z-index: 100

    .btn-loader
        padding: 0 !important
        margin: 0 0 0 20px !important
        height: 20px
        border: 0

    .page-header
        margin: 0 auto 2rem auto
        padding: 10px 15px
        background: #fafafa
        font-size: 1.25rem
        &.has-alert
            margin-bottom: 0.5rem

    .auto-cc-alert
        margin: 0 auto 2rem auto
        padding: 10px 15px
        background: #fff5ef
        color: #d03c1f
        font-weight: 700

    .section-accept
        margin: 0 auto 2rem auto
        padding: 1rem 0
        @media (max-width: 768px)
            margin-bottom: 0.5rem
            padding: 10px 1.5rem
        font-size: 1.25rem
        color: #000
        a
            color: #777
            text-decoration: underline
        button
            color: #fff
            background: orange
            border: none
            font-weight: 700
            font-size: 1.5rem
            min-width: 200px
            padding: 14px auto
            @media (max-width: 768px)
                width: 100%
            &.btn-invite--secondary
                background: #dedede
                color: #878787
            &.btn-loader
                background: none
                min-width: 0
    .section-quote-bx
        padding: 40px 80px;
        background: #fff;
        @media (min-width: 1280px)
            margin: 0 80px;
        .quote-logo
            margin-bottom: 30px;
        .quote-title
            margin-bottom: 20px;
        ul
            margin-bottom: 60px;
            list-style: disc;
            padding-inline-start: 20px;
            li
                margin-bottom: 20px;
        button
            &.btn-invite--secondary
                background: #dedede
                color: #878787

    .section-accept--menu
        position: fixed
        top: 100px
        right: 7px
        padding: 5px
        background: rgba(255, 255, 255, 0.5)
        font-size: 0.9rem
        z-index: 1
        button
            font-size: 0.9rem
            min-width: 100px
            display: block
            padding: 5px
            &.btn-invite--secondary
                display: block

        @media (max-width: 768px)
            top: 75px
            right: 0

    .tabs.is-boxed a
        font-size: 1.2rem
        font-weight: 400

    .margin-top-30
        margin-top: 30px

    .uploads-list
        padding: 0 0 0 20px
        li
            font-size: 0.9rem

    .recipe-item .recipe-item-description.recipe-item-description
        padding-left: 21px
</style>
